"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_system_1 = require("styled-system");
var Text_1 = __importDefault(require("./Text"));
var Heading = styled_components_1["default"](Text_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n"], ["\n  font-family: ", ";\n"])), styled_system_1.themeGet('headingFont'));
Heading.displayName = 'Heading';
Heading.defaultProps = {
    fontSize: 4,
    fontWeight: 'bolder',
    lineHeight: 'display',
    color: 'primary'
};
exports["default"] = Heading;
var templateObject_1;
//# sourceMappingURL=Heading.js.map